module.exports = __webpack_public_path__ + "static/media/carsRentalImage11.fb210233.png";